import _ from 'underscore';
import View from 'view/base';

var Calendar = View.extend({
    className: 'feedback-time-usage',

    events: {
    },

    initialize: function(chart_data) {
        this.chart_data = chart_data;
    },

    getLevel: function(day, time) {
        if (!this.max) {
            this.max = 0;
            _.each(this.chart_data, function(day_data) {
                this.max = Math.max(this.max, _.max(day_data));
            }, this);
        }

        var count = this.chart_data[day][time];

        if (count === 0) {
            return 'level';
        } else if (count < this.max * 0.2) {
            return 'level1';
        } else if (count < this.max * 0.4) {
            return 'level2';
        } else if (count < this.max * 0.6) {
            return 'level3';
        } else if (count < this.max * 0.8) {
            return 'level4';
        } else {
            return 'level5';
        }
    },

    render: function() {
        var content = '';

        content += '<div class="inner-scroll">';

        content += '<div class="heading">' +
                        '<div>1am</div>' +
                        '<div>4am</div>' +
                        '<div>7am</div>' +
                        '<div>10am</div>' +
                        '<div>1pm</div>' +
                        '<div>4pm</div>' +
                        '<div>7pm</div>' +
                        '<div>10pm</div>' +
                    '</div>';

        content += '<div class="time">' +
                        '<div class="day">Mon</div>' +
                        '<div class="day">Tue</div>' +
                        '<div class="day">Wed</div>' +
                        '<div class="day">Thu</div>' +
                        '<div class="day">Fri</div>' +
                        '<div class="day">Sat</div>' +
                        '<div class="day">Sun</div>' +
                    '</div>';

        for (var i = 0; i <= 23; i++) {
            content += '<div class="time">';
            for (var j = 0; j < 7; j++) {
                var level = this.getLevel(j, i);
                var count = this.chart_data[j][i];
                content += '<div class="tooltip ' + level + '" data-title="' + count + ' feedback collected"></div>';
            }
            content += '</div>';
        }
        content += '</div>';

        content += '<div class="legend">' +
                        '<div class="text-info">Less</div>' +
                        '<div class="level1"></div>' +
                        '<div class="level2"></div>' +
                        '<div class="level3"></div>' +
                        '<div class="level4"></div>' +
                        '<div class="level5"></div>' +
                        '<div class="text-info">More</div>' +
                    '</div>';

        this.$el.html(content);

        return this;
    }
});

export default Calendar;